import callAPiBase from './base';

const messagesCountApi = {
  list: ({ startDate, endDate }: { startDate: number; endDate: number }) =>
    callAPiBase({
      endpoint: `/api/reports/messages/count/messages?startDate=${startDate}&endDate=${endDate}`,
      method: 'GET',
      useToken: true,
    }),
};

export { messagesCountApi };
export default messagesCountApi;
